'use client';

import { Container } from 'components/gruenland/atoms/container/Container';
import HubspotForm, { HubspotFormProps } from 'components/gruenland/organisms/hubspot/HubspotForm';
import { TasticProps } from 'frontastic/tastics/types';

const YggdrasilHubspotFormTastic = ({ data }: TasticProps<HubspotFormProps>) => {
  return (
    <Container>
      <HubspotForm portalId={data.portalId} formId={data.formId} />
    </Container>
  );
};

export default YggdrasilHubspotFormTastic;
